<template>
  <div id="intro">
    <div>인사말</div>
    <div>
      <div>
        <div>
          구로중장년 일드림센터는 구직자들의<br>
          취업성공을 위한 다양한 교육 프로그램을<br>
          제공합니다.
        </div>
        <div>
          홈페이지를 방문해주신 여러분께 깊은 감사를 드립니다.<br>
          <br>
          구로구 중장년 일드림센터에서는 인력난을 겪고 있는 구인업체와
          취업을 희망하는 구직자에게 도움이 되고자
          취업알선, 직업훈련 정보제공 등의 고용서비스를 제공하고자 합니다.<br>
          <br>
          다양하고 전문적인 취업지원서비스로 구직자에게는 만족스러운 일자리를,
          구인업체에는 적합한 인재를 연결하도록 1:1 맞춤 생애설계로 진로설정 및
          재취업을 지원하여 중장년 삶의 질을 향상시키는데 기여하고자 합니다.<br>
          <br>
          구직자의 취업능력 향상을 위해 취업지원 프로그램을 운영하고,
          구인구직 만남의 날을 통해 기업체와 구직자간의 만남의 장을 마련하여,
          양질의 일자리 창출에 노력하겠습니다.<br>
          <br>
          보다 나은 서비스를 제공하고자 구로 중장년 일드림센터 직원 일동은
          더 나은 내일, 함께 여는 구로에 발 맞추고자 합니다.<br>
          <br>
          감사합니다.
        </div>
      </div>
      <div>
        <img src="../../assets/intro/intro_bg_w_02.png" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
  }
}
</script>

<style scoped>
#intro {
  display: flex;
  flex-direction: column;
  width: 1140px;
  margin: auto;
}

.mobile_wrap #intro {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

#intro > div:nth-child(1) {
  margin-top: 55px;
  font-size: 38px;
  font-weight: 700;
  text-align: left;
}

.mobile_wrap #intro > div:nth-child(1) {
  margin-top: 40px;
  font-size: 18px;
}

#intro > div:nth-child(2) {
  display: flex;
  margin: 70px 0 190px;
  gap: 30px;
}

.mobile_wrap #intro > div:nth-child(2) {
  flex-direction: column;
  margin: 18px 0 66px;
  gap: 40px;
}

#intro > div:nth-child(2) > div:nth-child(1) {
  flex-shrink: 1;
  width: 100%;
}

#intro > div:nth-child(2) > div:nth-child(2) {
  flex-shrink: 0;
  width: 460px;
}

.mobile_wrap #intro > div:nth-child(2) > div:nth-child(2) {
  width: 100%;
}

#intro > div:nth-child(2) > div > div:nth-child(1) {
  font-size: 36px;
  font-weight: 700;
  line-height: 150%;
  text-align: left;
}

.mobile_wrap #intro > div:nth-child(2) > div > div:nth-child(1) {
  font-size: 16px;
}

#intro > div:nth-child(2) > div > div:nth-child(2) {
  margin-top: 40px;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  text-align: left;
  word-break: keep-all;
}

.mobile_wrap #intro > div:nth-child(2) > div > div:nth-child(2) {
  margin-top: 25px;
  font-size: 14px;
}

#intro > div:nth-child(2) > div > img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/intro/Intro.vue